export default __webpack_public_path__ + "static/media/people.712627d6.svg";